import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, ExternalLink } from 'lucide-react';
import { useSettings } from '../../context/SettingsContext';
import './Footer.css';

export default function Footer() {
  const s = useSettings();
  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        <div>
          <p className="footer-title">{s.site_name || 'Spitali i Prizrenit'}</p>
          <p className="footer-sub">{s.site_subtitle}</p>
          <div className="footer-contacts">
            <a href={`tel:${s.main_phone}`} className="footer-contact-row">
              <Phone size={14}/> {s.main_phone || '+383 29 243 134'}
            </a>
            <a href={`mailto:${s.email}`} className="footer-contact-row">
              <Mail size={14}/> {s.email || 'spitali.prizren@rks-gov.net'}
            </a>
            <span className="footer-contact-row">
              <MapPin size={14}/> {s.address || 'Rruga Shkronjat, 20000 Prizren'}
            </span>
          </div>
        </div>

        <div>
          <p className="footer-col-title">Navigimi</p>
          <div className="footer-links">
            {[['/', 'Ballina'], ['/departamentet','Departamentet'],
              ['/sherbimet','Shërbimet'],['/lajmet','Lajmet'],
              ['/publikimet','Publikimet'],['/historiku','Historiku']
            ].map(([to, label]) => (
              <Link key={to} to={to} className="footer-link">{label}</Link>
            ))}
          </div>
        </div>

        <div>
          <p className="footer-col-title">Lidhje të rëndësishme</p>
          <div className="footer-links">
            <a href="https://msh.rks-gov.net" target="_blank" rel="noreferrer" className="footer-link ext">
              <ExternalLink size={12}/> Ministria e Shëndetësisë
            </a>
            <a href="https://shskuk.rks-gov.net" target="_blank" rel="noreferrer" className="footer-link ext">
              <ExternalLink size={12}/> SHSKUK
            </a>
          </div>
          <div className="emergency-box">
            <p className="emergency-label">Emergjenca 24h</p>
            <a href={`tel:${s.emergency_phone}`} className="emergency-num">
              {s.emergency_phone || '+383 45 104 230'}
            </a>
            <p className="emergency-label" style={{marginTop:8}}>Linja falas</p>
            <a href={`tel:${s.free_line}`} className="emergency-num free">
              {s.free_line || '0800 17777'}
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <span>© {new Date().getFullYear()} {s.site_name || 'Spitali i Përgjithshëm i Prizrenit'}. Të gjitha të drejtat e rezervuara.</span>
          {/* <Link to="/admin/login" className="admin-link">Hyrja e Adminit</Link> */}
        </div>
      </div>
    </footer>
  );
}
